var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.closePopup,
          expression: "closePopup",
        },
      ],
      staticClass: "DateFilter filterWrapper",
      class: { open: _vm.popupOpen },
    },
    [
      _c("div", { staticClass: "lgrid-noGutter-noWrap title-wrapper" }, [
        _c(
          "button",
          {
            staticClass: "title",
            class: { active: _vm.isActive },
            on: { click: _vm.openPopup },
          },
          [_c("span", { domProps: { innerHTML: _vm._s(_vm.placeholder) } })]
        ),
      ]),
      _c(
        "div",
        { staticClass: "filter--popup" },
        [
          _vm.popupOpen
            ? _c("date-picker", {
                attrs: {
                  placeholder: _vm.placeholder,
                  mode: _vm.mode,
                  options: _vm.conf.calendarOptions,
                  forceRange: _vm.conf.forceRange,
                },
                on: { apply: _vm.apply, close: _vm.closePopup },
                model: {
                  value: _vm.date,
                  callback: function ($$v) {
                    _vm.date = $$v
                  },
                  expression: "date",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }